import i18n from "@/i18n";
import { VariableItem } from "@/modules/ckeditor/TextEditor";
import ReactDOMServer from "react-dom/server";
import {
  LETTER_HEADER_VARIABLE,
  LetterHeaderContent,
  PAGECONFIG_TO_PIXEL_RATIO,
} from "./BFDocument.service";
import { DOCUMENT_FONT_FAMILY } from "./BFDocumentView";

// 90 mm von oben - geblockt für header
// Absender : x 23, y  45 , height 5,5, width 85,  font Ariel 8pt
// Empfänger: x 23, y 69, height 21, width 85, 6 rows, font Ariel 9pt

interface BFLetterHeaderProps {
  content: LetterHeaderContent;
  debug?: boolean;
  ignoreActvity?: boolean;
}
export const getLetterHeader = (content: LetterHeaderContent, debug = false) =>
  ReactDOMServer.renderToString(
    <BFLetterHeader content={content} debug={debug} />
  );
const BFLetterHeader = (props: BFLetterHeaderProps) => {
  const variables = LETTER_HEADER_VARIABLE();

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: 70 * PAGECONFIG_TO_PIXEL_RATIO,
      }}
    >
      {props.content.logo && (
        <div
          className={`letter-header__logo`}
          style={{
            position: "absolute",
            top: 0 * PAGECONFIG_TO_PIXEL_RATIO,
            left: 10 * PAGECONFIG_TO_PIXEL_RATIO,
            right: 10 * PAGECONFIG_TO_PIXEL_RATIO,
            height: 10 * PAGECONFIG_TO_PIXEL_RATIO,
            backgroundImage: `url(${props.content.logo})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "50% 50%",
            border: props.debug ? `solid 2px red` : undefined,
          }}
        ></div>
      )}
      <div
        className={`letter-header__sender`}
        style={{
          position: "absolute",
          top: 24 * PAGECONFIG_TO_PIXEL_RATIO,
          left: 2 * PAGECONFIG_TO_PIXEL_RATIO,
          height: 5.5 * PAGECONFIG_TO_PIXEL_RATIO,
          width: 120 * PAGECONFIG_TO_PIXEL_RATIO,
          //   width: 85 * PAGECONFIG_TO_PIXEL_RATIO,
          border: props.debug ? `solid 2px red` : undefined,
          fontFamily: DOCUMENT_FONT_FAMILY,
          fontSize: 12,
          lineHeight: "12px",
          color: "#000",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        <LetterVariable
          variables={variables}
          variableId="senderName"
          value={props.content.sender.name}
        />
        {", "}
        <LetterVariable
          variables={variables}
          variableId="senderStreet"
          value={props.content.sender.street}
        />
        {", "}
        <LetterVariable
          variables={variables}
          variableId="senderZip"
          value={props.content.sender.zip}
        />{" "}
        <LetterVariable
          variables={variables}
          variableId="senderCity"
          value={props.content.sender.city}
        />
      </div>
      <div
        className={`letter-header__receiver`}
        style={{
          position: "absolute",
          top: 48 * PAGECONFIG_TO_PIXEL_RATIO,
          left: 2 * PAGECONFIG_TO_PIXEL_RATIO,
          height: 21 * PAGECONFIG_TO_PIXEL_RATIO,
          width: 85 * PAGECONFIG_TO_PIXEL_RATIO,
          border: props.debug ? `solid 2px red` : undefined,
          fontSize: 12,
          fontFamily: DOCUMENT_FONT_FAMILY,
          lineHeight: "15px",
          color: "#000",
        }}
      >
        <LetterVariable
          variables={variables}
          variableId="receiverName"
          value={props.content.receiver.name}
        />
        <br />
        <LetterVariable
          variables={variables}
          variableId="receiverStreet"
          value={props.content.receiver.street}
        />
        <br />
        <LetterVariable
          variables={variables}
          variableId="receiverCity"
          value={props.content.receiver.city}
        />
        <br />
        <LetterVariable
          variables={variables}
          variableId="receiverCountry"
          value={props.content.receiver.country}
        />
      </div>

      <div
        style={{
          position: "absolute",
          bottom: 30,
          right: 0 * PAGECONFIG_TO_PIXEL_RATIO,
          fontSize: 12,
          fontFamily: DOCUMENT_FONT_FAMILY,
          lineHeight: "15px",
          color: "#000",
          textAlign: "right",
        }}
      >
        <div
          style={{
            maxWidth: 48 * PAGECONFIG_TO_PIXEL_RATIO,
            display: "inline-block",
            paddingBottom: 10,
          }}
        >
          <strong>
            <LetterVariable
              variables={variables}
              variableId="senderName"
              value={props.content.sender.name}
            />
          </strong>
          <br />
          <LetterVariable
            variables={variables}
            variableId="senderStreet"
            value={props.content.sender.street}
          />
          <br />
          <LetterVariable
            variables={variables}
            variableId="senderZip"
            value={props.content.sender.zip}
          />{" "}
          <LetterVariable
            variables={variables}
            variableId="senderCity"
            value={props.content.sender.city}
          />
        </div>
        <br />
        {i18n.t("BFLetterHeader.tel", "Tel.")}:{" "}
        <LetterVariable
          variables={variables}
          variableId="senderPhone"
          value={props.content.sender.phone}
        />
        <br />
        {i18n.t("BFLetterHeader.fax", "Fax.")}:{" "}
        <LetterVariable
          variables={variables}
          variableId="senderFax"
          value={props.content.sender.fax}
        />
        <br />
        {i18n.t("BFLetterHeader.mail", "E-Mail")}:{" "}
        <LetterVariable
          variables={variables}
          variableId="senderMail"
          value={props.content.sender.mail}
        />
        <br />
        <LetterVariable
          variables={variables}
          variableId="senderWebsite"
          value={props.content.sender.website}
        />
        {props.ignoreActvity ? null : (
          <>
            <br />
            <br />
            {i18n.t("BFLetterHeader.activityId", "Aktenzeichen")}:{" "}
            <LetterVariable
              variables={variables}
              variableId="activityId"
              value={props.content.activityId}
            />
          </>
        )}
      </div>
      <div
        style={{
          position: "absolute",
          bottom: 0,
          right: 0 * PAGECONFIG_TO_PIXEL_RATIO,
          fontSize: 12,
          fontFamily: DOCUMENT_FONT_FAMILY,
          lineHeight: "12px",
          color: "#000",
        }}
      >
        <LetterVariable
          variables={variables}
          variableId="senderCity"
          value={props.content.sender.city}
        />
        {", "}
        <LetterVariable
          variables={variables}
          variableId="documentDate"
          value={props.content.documentDate}
        />
      </div>
    </div>
  );
};

export default BFLetterHeader;

const LetterVariable = (props: {
  value?: string;
  variableId: string;
  variables: VariableItem[];
}) => {
  if (props.value) {
    return <>{props.value}</>;
  }
  const element = props.variables.find((e) => e.id === props.variableId);
  if (!element) {
    return null;
  }
  return (
    <span className="mention-variable" data-variable-id={element.id}>
      ${element.name}
    </span>
  );
};
